import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const ActiveBlockBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const activeBlock = useStore(state => state.activeBlock)
  const setActiveBlock = useStore(state => state.setActiveBlock)

  const state = { activeBlock: activeBlock }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-actvblockustand", 1000)
    if (role === "recipient") {
      socket.current.on("actvblockustand", zustand => {
        setActiveBlock(zustand.activeBlock)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("actvblockustand", state)
    }
  }, [state, role, url])

  return null
}

ActiveBlockBroadcaster.propTypes = {}

export default ActiveBlockBroadcaster
